export class KelydraUtils {

  public static debounce(func:Function, wait:number, _this:any) {
    if (wait <= 0) {
      return function(...args:any) {
        func.apply(_this, args);
      }
    }

    let timeout:any

    if ((<any>func)['_debounce']) {
      return (<any>func)['_debounce'];
    }

    (<any>func)['_debounce'] = function(...args:any) {
      const context:any = _this;
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(context, args), wait)
    }

    return (<any>func)['_debounce'];
  }


  public static dragElement(elmnt:HTMLElement) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    elmnt.onmousedown = dragMouseDown;
  
    function dragMouseDown(e:MouseEvent) {
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e:MouseEvent) {
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  public static handleResize(e:MouseEvent, resizeWidth:boolean, resizeHeight:boolean, elementToResize?:HTMLElement) {
    e.preventDefault();

    if (!elementToResize) {
      elementToResize = (e.target as HTMLElement).parentElement;
    }

    let startSize = {width:elementToResize.clientWidth, height:elementToResize.clientHeight};
    let startMouse ={clientX:e.clientX, clientY:e.clientY};


    let elementDrag = (e:MouseEvent) => {
      e.preventDefault();
      // set the element's new position:

      if (resizeWidth) {
        let deltaX = e.clientX - startMouse.clientX;
        elementToResize.style.width = (startSize.width + deltaX) + 'px';
      }

      if (resizeHeight) {
        let deltaY = e.clientY - startMouse.clientY;
        elementToResize.style.height = (startSize.height + deltaY) + 'px';
      }
    }


    let closeDragElement = () => {
      document.removeEventListener('mouseup', closeDragElement);
      document.removeEventListener('mousemove', elementDrag);
    }

    document.addEventListener('mouseup', closeDragElement);
    document.addEventListener('mousemove', elementDrag);
  
  
  }

  public static htmlToText(html:string) {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.innerText;
  }

  public static getQueryParameter(name:string, url?:string):string {
    return KelydraUtils.getQueryParameters(url).get(name)
  }

  public static getQueryParameters(url?:string):URLSearchParams {
    if (!url) {
      url = window.location.href;
    }

    const startIdx = url.indexOf('?');
    return new URLSearchParams(startIdx >= 0 ? url.substring(startIdx) : '');
  }


  public static setCookie(name:string,value:string, days:number) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  public static getCookie(name:string) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  public static eraseCookie(name:string) {
    document.cookie = name+'=; Max-Age=-99999999;';
  }



}
